import { useEffect } from 'react'

/**
 * Nhớ search params (filter + page) gần nhất của mỗi màn danh sách trong phiên.
 * Nút "Quay lại" trên trang chi tiết đọc lại giá trị này để luôn đưa người dùng
 * về đúng danh sách kèm bộ lọc đã dùng — kể cả khi trang chi tiết được mở từ nơi
 * khác (đơn hàng, lô) hoặc sau một thao tác xoá. Bộ nhớ chỉ sống trong phiên tab;
 * reload trang thì nút back rơi về danh sách sạch (browser back vẫn khôi phục URL).
 */
const store = new Map<string, unknown>()

export const LIST_SEARCH_KEYS = {
    products: 'products',
    stockInNotes: 'stock-in-notes',
    stockOutNotes: 'stock-out-notes',
    transferNotes: 'transfer-notes',
    orders: 'orders',
} as const

export function rememberListSearch(key: string, search: unknown): void {
    store.set(key, search)
}

export function recallListSearch<T>(key: string): T | undefined {
    return store.get(key) as T | undefined
}

/** Ghi nhớ search hiện tại của danh sách mỗi khi nó đổi. */
export function useRememberListSearch(key: string, search: unknown): void {
    useEffect(() => {
        rememberListSearch(key, search)
    }, [key, search])
}
